import React from 'react';
import ReactDOM from 'react-dom';
import PublicationItem from './publication-item.jsx';
import PublicationsFilter from './publications-filter.jsx';
import LoadMore from './load-more.jsx';
import { populate } from './../utils/populate.js';

class Publications extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      baseQuery: "/rest/publications?_format=json",
      query: "&document_type_exclude=13",
      data: [],
      preloadData: [],
      loadMore: false,
      page: 0,
      pageCount: 9,
      keyword: "",
      committee: "All",
      document: "All",
      paper: "All",
      service: "All",
      date: ""
    };

    this.populateAll = this.populateAll.bind(this);
    this.prePopulate = this.prePopulate.bind(this);
    this.processChange = this.processChange.bind(this);
    this.parseEndpoint = this.parseEndpoint.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.userUpdate = this.userUpdate.bind(this);
  }

  componentDidMount() {
    var t = this,
      n = this.parseEndpoint("committee"),
      r = this.parseEndpoint("document_type"),
      a = this.parseEndpoint("paper_type"),
      o = this.parseEndpoint("date"),
      i = this.parseEndpoint("service");

    if (null != n || null != r || null != a || null != o || null != i) {
      var s = n ? "&committee=" + n : "",
        l = r ? "&document_type=" + r : "",
        u = a ? "&paper_type=" + a : "",
        c = o ? "&date=" + o : "",
        d = i ? "&service=" + i : "",
        p = s + l + u + c + d;
      13 != r && (p += "&document_type_exclude=13"), t.setState({
        committee: n ? n : "All",
        document: r ? r : "All",
        paper: a ? a : "All",
        date: o ? o : "",
        service: i ? i : "",
        query: p
      }, () => {
        this.populateAll();
        this.prePopulate();
      })
    } else {
      this.populateAll();
      this.prePopulate();
    }
  }

  parseEndpoint(e, t) {
    t || (t = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
    let n = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)"),
      r = n.exec(t);
    return r ? r[2] ? decodeURIComponent(r[2].replace(/\+/g, " ")) : "" : null
  }

  populateAll() {
    const { baseQuery, query } = this.state;
    const that = this;
    populate(`${baseQuery}&page=${that.state.page}${query !== '' && query}`).then(function( response ){
      console.log('response', response)
      that.setState({
        data: response
      })
    });
  }

  prePopulate() {
    const { baseQuery, query } = this.state;
    const that = this;
    populate(`${baseQuery}&page=${that.state.page + 1}${query !== '' && query}`).then(function( response ){
      if(response.length !== 0){
        that.setState({
          preloadData: response,
          loadMore: true
        })
      }else{
        that.setState({
          preloadData: [],
          loadMore: false
        })
      }
    });
  }

  onInputChange(input){
    this.setState({
      keyword: input
    })
  }

  processChange() {
    if (this.state.preloadData.length < this.state.pageCount){
        this.setState({
        data: this.state.data.concat(this.state.preloadData),
        preloadData: [],
        loadMore: !1
      });
    } else {
      var e = parseInt(this.state.page) + 1;
      this.setState({
        page: e,
        data: this.state.data.concat(this.state.preloadData),
        preloadData: []
      }, () => {
        this.prePopulate()
      })
    }
  }

  userUpdate(textInput, committee, document, paper, date, service) {
    let textQuery = textInput ? "&keys=" + textInput : "";
    let committeeQuery = committee ? "&committee=" + committee : "";
    let documentQuery = document ? "&document_type=" + document : "";
    let paperQuery = paper ? "&paper_type=" + paper : "";
    let dateQuery = date ? "&date=" + date : "";
    let serviceQuery = service ? "&service=" + service : "";
    let query = textQuery + committeeQuery + documentQuery + paperQuery + dateQuery + serviceQuery;
    13 != document && (query += "&document_type_exclude=13"), console.log(query), this.setState({
      keyword: textInput ? textInput : "",
      committee: committee ? committee : "All",
      document: document ? document : "All",
      paper: paper ? paper : "All",
      date: date ? date : "",
      service: service ? service : "All",
      page: 0,
      query: query
    }, () => {
      this.populateAll();
      this.prePopulate();
    })
  }

  render() {
    const { data, loadMore} = this.state;
      return(
        <div className="publication--articles">
          <PublicationsFilter
            title="Publications filter"
            filterKeyword={this.state.keyword}
            filterCommittee={this.state.committee}
            filterDocument={this.state.document}
            filterPaper={this.state.paper}
            filterService={this.state.service}
            filterDate={this.state.date}
            onUserInput={this.userUpdate}
            onInputChange={this.onInputChange}
          />
          <div className="publication--articles--holder grid">
          {
            data.map((item, index) => {
              return(
                <PublicationItem item={item} key={index} />
              );
            })
          }
          </div>
          { data.length !== 0 && <LoadMore display={loadMore} onUpdate={this.processChange} /> }
        </div>
      )
  }
}

if ( document.getElementById('react--publication--filter') ) {
  ReactDOM.render(
    <Publications />,
    document.getElementById('react--publication--filter')
  );

}









